import React from 'react'
import { IconButton, Typography, ListItem, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
const Item = ({ id,test, removeTest }) => {
  
  function handleRemoveClick() {
    removeTest(test, id);
  }

  return (
    
    <ListItem className='card' key={id} style={{justifyContent:'center',width:'auto'}}>
      <Typography >
        {test}
      </Typography>
      < IconButton onClick={handleRemoveClick}>
        <CloseIcon />
      </IconButton>
    </ListItem>
  );
}

export default Item
